var _path, _line, _line2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentsTypesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.5V14.166C18 15.5467 16.8807 16.666 15.5 16.666H14.5827H6.66602C5.28531 16.666 4.16602 15.5467 4.16602 14.166V3.16602H14.9993V12.0827",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.66602,
    y1: 6.375,
    x2: 12.4993,
    y2: 6.375,
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.66602,
    y1: 8.875,
    x2: 9.16602,
    y2: 8.875,
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.4987L15 14.332C15 15.1605 15.6716 15.832 16.5 15.832C17.3284 15.832 18 15.1605 18 14.332L18 12.4987L15 12.4987Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsTypesIcon);
export default __webpack_public_path__ + "static/media/documents-types-icon.8be49647829ea2d05937f09ab26d36aa.svg";
export { ForwardRef as ReactComponent };